/*
* @描述: 人事管理设置字段
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2024-10-28 15:32:30
*/
<template>
    <div class="set_fields_wrap">
        <CustomFormSite
            :can_set_show_rules="false"
            :field_form_desc="'点击可对各字段单独设置，按住可拖动排序字段位置，可同步入职登记表显示'"
            :field_form_title="'新增员工预览区'"
            :review_form_type_list="reviewFormTypeList"
            :field_form="'users'"
            :is_form_module="true"
            :is_two_column="true"
            :publish_btn_show="true"
            :review_btn_show="true"
        />
        <FormTplSelect
            v-if="formTplDialog"
            :formTplDialog.sync="formTplDialog"
            :formTplTitle="'表单模版'"
            :formTplDesc="formTplDesc"
            :formTplList="formTplList"
            :field_form="fieldForm"
            :field_form_title="'新增员工'"
            :formTplPreviewDesc="formTplPreviewDesc"
        />
    </div>
</template>
<script>
import CustomFormSite from "@/components/pComponents/CustomFormSite";
import FormTplSelect from "@/components/pComponents/FormTplSelect.vue";

export default {
    name: "set_fields",
    data() {
        return {
            reviewFormTypeList: [
                { title: "新增员工电脑端", value: "pc", form_title: "新增员工", form_desc: "" },
                { title: "新增员工移动端", value: "mobile", form_title: "新增员工", form_desc: "" },
                { title: "入职登记表", value: "entry_registration", form_title: "入职登记表", form_desc: "" },
            ],
            formTplDialog: false,
            formTplDesc: "您可以选择以下模版，帮助您快速配置字段，使用后也可以自定义修改内容或添加新字段",
            formTplList: [
                {
                    type: 1,
                    title: "模版一",
                    desc: "注重员工关键信息",
                    secTitle: "新增员工",
                    thumbnail: "https://download.hecoos.com/enlightv/2024-47/c4d18ad9ca5cca16e4a9ccf4362faf14.png",
                },
                {
                    type: 2,
                    title: "模版二",
                    desc: "注重员工工作信息",
                    secTitle: "新增员工",
                    thumbnail: "https://download.hecoos.com/enlightv/2024-47/d7c82f05caa5c9a360deb6aa6d762891.png",
                },
                {
                    type: 3,
                    title: "模版三",
                    desc: "注重员工基本信息",
                    secTitle: "新增员工",
                    thumbnail: "https://download.hecoos.com/enlightv/2024-47/771d4bafb52b7294da5ad1cfca66d550.png",
                },
                {
                    type: 4,
                    title: "模版四",
                    desc: "模版合集，员工各维度的信息",
                    secTitle: "新增员工",
                    thumbnail: "https://download.hecoos.com/enlightv/2024-47/a2354d2cb936d9dc694647ab6642ba4e.png",
                },
            ],
            formTplPreviewDesc:
                "模拟真实新增员工页面效果，预览中填写的数据系统不会保存，有些控件如附件、图片、身份证不支持在预览中操作",
            fieldForm: "users"
        };
    },
    components: { CustomFormSite, FormTplSelect },
    created() {
        this.formTplDialog = true
    },
    mounted() {},
    methods: {},
};
</script>
<style lang="scss" scoped>
.set_fields_wrap {
    width: 100%;
    height: 100%;
}
</style>
